import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const sendSignIn = async (payload) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/cognito/initiate-login `,
      payload
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const verifyMFACode = async (payload) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/cognito/confirm-login`,
      payload
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};
